<template>
<div class="profile-update update-form container row">
  <div class="center col-xs-12 col-sm-12 col-md-6 col-lg-4">
    <div class="profile">
      <user-image
        :firstname="currentUser.firstname"
        :lastname="currentUser.lastname"
        :email="currentUser.email == 'unknown' ? '' : currentUser.email"
        size="medium"
        theme="sensual-lighter"
      />
      <p> {{ item.email }} </p>
      <p v-if="item.organization">
        {{ item.organization.name}}
      </p>
      <sensual-badge
        v-if="item.role"
        color="dark"
        :text="item.role"
      />
      <router-link class="forgot-password" :to="{name:'password_reset_request'}">{{$t('ui.meta_info.reset_password')}}</router-link>
    </div>
    <form class="profile-update--form" @submit.prevent="update">
      <field :errors="errors" name="firstname" label="models.user.firstname" v-model="firstName"  placeholder="Andy"></field>
      <field :errors="errors" name="lastname" label="models.user.lastname" v-model="lastName"   placeholder="Kaufman"></field>
      <div class="update-form--actions">
        <button class="btn btn-tertiary" @click="cancel">{{ $t('ui.global.cancel') }}</button>
        <button class="btn btn-primary" type="submit">{{ $t('ui.global.save') }}</button>
      </div>
    </form>
  </div>
</div>
</template>
<script>
import Api from '@/api/User.js'
import OrganizationApi from '@/api/Organization.js'
import {updateMixin} from '@/components/mixins/Update'
import Permission from '@/classes/Permission'
import SensualBadge from '@/components/helpers/DataDisplay/SensualBadge'
import Ui from '@/classes/Ui'
import UserImage from '@/components/helpers/Specific/UserImage'

export default {
  mixins: [updateMixin],
  components: {
    SensualBadge,
    UserImage
  },
  data(){
    return {
      model: "users",
      api: new Api(),
      organizations: [],
    }
  },
  mounted () {
    this.retrieve_organizations()
    Ui.clearHeaderButtons()
  },
  methods: {
    retrieve_organizations(){
      let permission = Permission.loadPermissions()
      if (Permission.can(permission, 'organizations.list')) {
        let api = new OrganizationApi()
        api.all_for_association('name').then((items) => {
          this.organizations = items
        }).catch(function(error) {
          console.log(error.response)
        })
      }
    },
    userData() {
      if (this.currentUser.email == "unknown") {
        return null
      } else {
        if ((this.currentUser.firstname == "" && this.currentUser.lastname == "") || (!this.currentUser.firstname && !this.currentUser.lastname)) {
          return this.currentUser.email
        } else {
          return `${this.currentUser.firstname} ${this.currentUser.lastname}`
        }
      }
    },
    userInitials() {
      if (this.currentUser.email == "unknown") {
        return '?'
      } else {
        if ((this.currentUser.firstname == "" || this.currentUser.lastname == "") || (!this.currentUser.firstname || !this.currentUser.lastname)) {
          return '?'
        } else {
          return `${this.currentUser.firstname.charAt(0)}${this.currentUser.lastname.charAt(0)}`
        }
      }
    },
  },
  watch: {
      'item.firstname' (firstName) {
        this.$store.commit('SET_CURRENT_USER_FIRSTNAME', firstName)
      },

      'item.lastname' (lastName) {
        this.$store.commit('SET_CURRENT_USER_LASTNAME', lastName)
      }
  },

  computed: {
    currentUser: {
      get() {
        return this.$store.getters.currentUser;
      }
    },

    firstName: {
      get() {
        return this.$store.getters.currentUser.firstname;
      },

      set(value) {
        this.item.firstname = value
      }
    },
    lastName: {
      get() {
        return this.$store.getters.currentUser.lastname;
      },

      set(value) {
        this.item.lastname = value
      }
    }
  },
}

</script>
<style lang="scss" scoped>
.center {
  margin: 0 auto;
}

.profile-update {
  margin-bottom: 20px;
}
.profile {
  padding: 0 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;

  h5 {
    font-weight: 500 !important;
    font-size: 20px !important;
    margin: 15px 0 3px;
  }
  p {
    font-size: 14px;
    color: $ink-lighter;
    margin: 0;
  }

  .sensual-badge {
    margin-top: 5px;
  }
}
.update-form--actions {
  margin-top: 1em;
  text-align: right;
  .btn-tertiary {
    margin-right: 1em;
  }
}

.forgot-password {
  font-weight: 500;
  font-size: 14px;
  margin: 15px 0;
}

</style>



// WEBPACK FOOTER //
// UserProfile.vue?977f2bca